import {
    CreatePlayerRequest,
    CreatePlayerResponse,
    UpdatePlayerNameRequest,
    UpdatePlayerNameResponse,
} from '../models/player';
import { storePlayerToken } from './player-identity-service';

class PlayerService {
    public async createPlayer(name: string) {
        try {
            const request: CreatePlayerRequest = {
                name,
            };
            const response = await fetch(`${process.env.REACT_APP_BASE_API_URL!}/players`, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json',
                },
                body: JSON.stringify(request),
            });
            if (!response.ok) {
                throw new Error(`Failed to create player: ${response.status} ${response.statusText}`);
            }
            const body = (await response.json()) as CreatePlayerResponse;
            storePlayerToken(body.id, body.userToken);
            return {
                body,
                status: response.status,
            };
        } catch (error) {
            console.error('Error creating player:', error);
            throw error;
        }
    }

    public async updatePlayerName(id: string, name: string, token: string) {
        const request: UpdatePlayerNameRequest = { name };
        const response = await fetch(`${process.env.REACT_APP_BASE_API_URL!}/players/${id}`, {
            method: 'PATCH',
            headers: {
                'Content-Type': 'application/json',
                'X-Player-Id': id,
                'X-User-Token': token,
            },
            body: JSON.stringify(request),
        });
        if (!response.ok) {
            throw new Error(`Failed to update player name: ${response.status} ${response.statusText}`);
        }
        return (await response.json()) as UpdatePlayerNameResponse;
    }
}

export const playerService = new PlayerService();
